// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__8nS3A","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2fSLn","obliqueLine":"membershipbadge_obliqueLine__1YdHf"};